export function findInContext(context, selector) {
  if (selector === '&') {
    return context;
  }
  else {
    return context.find(selector).addBack(selector);
  }
}

export function isDescendant(descendant, ancestor) {
  return descendant.closest(ancestor).length > 0;
}